module.exports = __webpack_public_path__ + "static/img/card.1682667.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/smart-door/card.png
// module id = /Kv8
// module chunks = 1